import type { ClientPermissionSet } from "../../store/state/user/types";

export const shouldShowPortalSwitcher = (permissions: ClientPermissionSet[]): boolean => permissions.length > 1;
